import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';

import { Filters } from './filters.model';

@Injectable()
export class FiltersService {

  constructor(private http: HttpClient) { }


}
